/**
 * ドロワーメニュー
 * <details>タグと<summary>タグを組み合わせて作成
 */

export default function initDrawer() {
  drawer();
}

// export default function initDrawer() {
//   const drawer = document.getElementById("js-site-drawer");
//   const openTrigger = document.getElementById("js-site-drawer-open");
//   const closeTriggers = document.querySelectorAll(".js-site-drawer-close");

//   // details要素の開閉時にaria-expandedを更新
//   drawer.addEventListener("toggle", () => {
//     const expanded = drawer.hasAttribute("open");
//     openTrigger.setAttribute("aria-expanded", expanded);
//   });
// }

function drawer() {
  const hamburger = document.querySelector(".js-hamburger");
  const drawer = document.querySelector(".js-drawer");
  const header = document.querySelector("#header");
  const drawerLinks = drawer?.querySelectorAll("a");
  const body = document.querySelector("body");

  if (!hamburger || !drawer) return;
  let isOpen = false;

  const toggleMenu = () => {
    isOpen = !isOpen;

    hamburger.classList.toggle("is-active", isOpen);
    drawer.classList.toggle("is-open", isOpen);
    header.classList.toggle("is-drawer-open", isOpen);
    body.classList.toggle("is-no-scroll", isOpen);

    hamburger.setAttribute("aria-label", isOpen ? "メニューを閉じる" : "メニューを開く");
    hamburger.setAttribute("aria-expanded", isOpen.toString());
  };

  const handleKeydown = (e) => {
    if (e.key === "Escape" && isOpen) {
      toggleMenu();
    }
  };

  // drawer内のリンクをクリックしたらメニューを閉じる
  const closeMenuOnClick = (e) => {
    if (isOpen) {
      toggleMenu();
    }
  };

  hamburger.addEventListener("click", toggleMenu);
  document.addEventListener("keydown", handleKeydown);
  drawerLinks.forEach((link) => link.addEventListener("click", closeMenuOnClick));

  const handleSticky = () => {
    const isMobile = window.innerWidth <= 1260;
    const scrollY = window.scrollY;
    const stickyStart = 600;

    // 初期化
    hamburger.classList.remove("is-sticky", "is-sticky-ready", "is-hidden");
    // hamburger.style.display = "grid";

    if (!isMobile) {
      hamburger.style.display = "none"; // PCサイズでは非表示に
      return;
    }

    const footer = document.querySelector(".l-footer");
    const footerTop = footer.getBoundingClientRect().top + window.scrollY;
    const hamburgerHeight = hamburger.offsetHeight;
    const hamburgerBottom = scrollY + 20 + hamburgerHeight; // top:20px想定

    const isTouchingFooter = hamburgerBottom >= footerTop;

    if (isTouchingFooter) {
      hamburger.classList.add("is-hidden");
    } else if (scrollY > stickyStart) {
      hamburger.classList.add("is-sticky", "is-sticky-ready");
    } else if (scrollY > stickyStart - 200) {
      hamburger.classList.add("is-sticky-ready");
    }

    //スマホ時表示崩れ対策のためのリフロー
    hamburger.style.display = 'none';
    void hamburger.offsetHeight;
    hamburger.style.display = 'flex';
  };

  window.addEventListener("scroll", handleSticky);
  window.addEventListener("resize", handleSticky);
  handleSticky();
}
